import * as React from 'react';
import { observer } from 'mobx-react';
import { Instance } from 'mobx-state-tree';

import { MtsTicket, StakeType, TicketStatusType, TicketType, OfferType, TicketTipsContainer, TicketBetListContainer, IAccountTypeKey } from 'eTip--common';

import { AMLOptionsComponent, TicketAndCouponHint, RateAdjustmentOptions, Summary } from 'common--design-library';
import { Ticket } from 'desktop--design-library';


export interface ITicketContainerProps {
    ticket: Instance<typeof MtsTicket>;
    clearCoupon: () => void;
    goToEventDetail: (eventId: number, offerType: OfferType) => void;
    roleForTest: string;
}

@observer
export class TicketContainer extends React.Component<ITicketContainerProps> {

    get store() {
        return this.props.ticket;
    }

    render() {
        const ticketState = this.store.ticketState;

        if (ticketState === TicketStatusType.Hint) {
            return <TicketAndCouponHint
                onAcceptOrReject={(hintAccepted) => this.store.couponPayWithHintAsync(hintAccepted)}
                hint={this.store.hintForUser}
                currencyIsMoney={this.store.isStakeAsMoney}
                isAcceptingHintInProgress={this.store.isAcceptingHintInProgress}
                canSwapPrimarySecondaryForButtons={false}
            />
        }
        else {
            return <Ticket
                errors={this.store.errors && this.store.errors.map(error => error)}
                errorsAboveSubmitButton={this.store.errorsAboveSubmitButtons}
                isSystem={this.store.isFinalTicketState ? this.store.auxIsSystem : this.store.isSystem}
                toggleSystem={(value) => {
                    if (this.store.isEnabledUI) {
                        if (value) {
                            this.store.setTicketTypeAsync(TicketType.System);
                        }
                        else {
                            this.store.setTicketTypeAsync(TicketType.Simple);
                        }
                    }
                }}
                toggleSystemColor={__IsMTSTipos__ ? this.store.template.switchColor : this.store.template.primaryColor}
                clearTicket={this.props.clearCoupon}
                prepareJustSentTicketCopy={this.store.prepareJustSentTicketCopyAsync}
                tips={<TicketTipsContainer
                    tips={[...this.store.selections]}
                    removeTip={this.store.removeTipAsync}
                    changeIsBanker={this.store.setIsBankerAsync}
                    isEnabledUI={this.store.isEnabledUI}
                    onGoToDetail={this.props.goToEventDetail}
                    canShowBanker={this.store.isSystem}
                    canShowAliasNumber={this.store.canShowAliasNumber}
                    isForOneTapBet={false}
                />}
                tipsCount={this.store.selections.length}
                canShowProductsInTicket={this.store.canShowProductsInTicket}
                summary={<Summary
                    stake={this.store.stake.value}
                    stakeMoneyForInfo={this.store.stakeMoneyForInfo}
                    stakeWhole={this.store.stakeWhole}
                    useDecimalPlacesForStake={this.store.useDecimalPlacesForStake}
                    maxStake={this.store.maxStake}
                    setStake={this.store.setStakeOrValidity}
                    stakeChanged={this.store.stakeChangedAsync}
                    isEnabledUI={this.store.isEnabledUI}
                    stakesFix={this.store.stakesFix}
                    rate={this.store.rate}
                    pricePotencial={this.store.potentialWin}
                    productFee={this.store.productFee}
                    oddsRateAdvantage={this.store.oddsRateAdvantage}
                    rateAdvantageFactor={this.store.rateAdvantageFactor}
                    areRatesUpToDate={this.store.areRatesUpToDate}
                    isModifyOddsInProgress={this.store.isValidateTicketInProgress}
                    isSystem={this.store.isSystem}
                    couponStakeType={this.store.stakeType}
                    isSummaryValid={this.store.isSummaryValid}
                    currency={this.store.currency}
                    canShowAverageRate={this.store.stakeType == StakeType.All}
                    canShowStakeWhole={this.store.stakeType != StakeType.All}
                    canShowStakeForBet={false}
                    canShowStakeForCoupon={this.store.stakeType === StakeType.All}
                    rateChangeOptions={<RateAdjustmentOptions
                        selectedOption={this.store.rateChangeAcceptType}
                        selectOption={(selectedOption) => this.store.setOrToggleAcceptedRateChangeAsync(selectedOption)}
                        isPercentAllowed={false}
                        isEnabledUI={this.store.isEnabledUI}
                    />}
                    handlingFeeValue={this.store.handlingFeeValue}
                    handlingFeePointsValue={this.store.handlingFeePointsValue}
                    ticketMaxStakeVisibility={this.store.ticketMaxStakeVisibility}
                    isFreeTicketAccountTypeSelected={this.store.isFreeTicketAccountTypeSelected}
                />}
                ticketPay={() => {
                    this.store.ticketPayAsync();
                }}
                ticketEvaluate={this.store.acceptChangedRatesAndEvaluateAsync}

                areRatesUpToDate={this.store.areRatesUpToDate}
                isAcceptChangedRatesAndEvalInProgress={this.store.isAcceptChangedRatesAndEvalInProgress}
                isTicketCopyInProgress={this.store.isTicketCopyInProgress}
                isEnabledUI={this.store.isEnabledUI}
                isSystemTicketUpdating={this.store.isSystemTicketUpdating}
                changeTicketStakeType={this.store.setStakeTypeAsync}
                ticketStakeType={this.store.stakeType}
                ticketStatus={this.store.ticketState}
                cardinalityNode={<TicketBetListContainer ticket={this.store} />}
                isCountDownEnabled={this.store.offerType == OfferType.Live}
                numberToCountDown={this.store.visualDelay}

                availableAccountTypes={[...this.store.availableAccountTypes]}
                setAcountType={(key: IAccountTypeKey) => { this.store.setAccountTypeAsync(key); }}
                selectedAccountType={this.store.selectedAccountType}
                getFreeTicketBonusUrl={() => this.store.getFreeTicketBonusUrl}

                canPrepareTicket={this.store.canPrepareTicket}
                prepareTicket={this.store.prepareTicketAsync}
                savedTicketNumber={this.store.savedTicketNumber}
                savedTicketExpiration={this.store.savedTicketExpiration}

                amlOptions={<AMLOptionsComponent
                    items={[...this.store.amlOptions.items]}
                    toggleOption={this.store.amlOptions.toggleAMLOption}
                    updateDisabled={this.store.amlOptions.updateDisabled}
                />}

                roleForTest={this.props.roleForTest}

            />
        }
    }
}
